(function () {
    var AddClientCtrl = (function () {
        function AddClientCtrl() {
            this.init.apply(this, arguments);
        }

        AddClientCtrl.prototype = {
            init: function ($scope, $mdDialog, MKioskService, mdPanelRef, $timeout, client, prevRouter, onClose) {
                $scope.vm = this;
                this.$scope = $scope;
                this.$mdDialog = $mdDialog;
                this.MKioskService = MKioskService;
                this.mdPanelRef = mdPanelRef;
                this.$timeout = $timeout;
                this.client = _.clone(client) || {
                    isTemporary: true
                };
                this.prevRouter = prevRouter;
                this.onClose = onClose;
            },
            goBack: function () {
                this.mdPanelRef.close();
            },
            submit: function (form) {
                var _this = this;
                if (form.$invalid)
                    return;
                if (this.prevRouter !== "clients") {
                    this.$mdDialog.hide(this.client);
                }

                this.mdPanelRef.close().then(function () {
                    _this.onClose(_this.client);
                });
            },
            onBtnSave: function () {
                this.$timeout(function () {
                    $('#internal-add-client-page').find(".btn-submit").trigger("click");
                }, 0, false);
            }
        };
        AddClientCtrl.$inject = ['$scope', '$mdDialog', 'MKioskService', 'mdPanelRef', '$timeout', 'client', 'prevRouter', 'onClose'];
        return AddClientCtrl;
    }());
    angular.module('internal.addclient', []).controller('AddClientCtrl', AddClientCtrl);
})();


